<template>
<div class="shopping-cart--payment" v-if="paymentData">
    <div class="row">
        <div class="col-12 col-sm-6" v-for="(option, index) in paymentData.options" :key="index">
            <div class="form-group">
                <div class="radio2">
                    <label>
                        <input name="paymetType" :value="index" type="radio" v-model="selectedOption" />
                        <span>
                            <div>
                                <div class="nameNoChange nameNarrow">
                                    <div class="rightContent">
                                      <template v-for="(icon) in option.icons">
                                        &nbsp;<i :key="icon" :class="icon"></i>
                                      </template>
                                    </div>
                                    {{ option.name }} <b class="text-salmon-red" v-if="option.value">+{{ option.value }} €</b>
                                </div>
                                <div class="text" v-if="option.text">{{ option.text }}</div>
                            </div>
                        </span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { createNamespacedHelpers as nsHelper } from 'vuex'

const {
  mapState,
  mapActions
} = nsHelper('cart/payment')

export default {

  computed: {
    ...mapState({
      paymentData: 'data',
      option: 'option'
    }),

    shippingOption () {
      return this.$store.state.cart.shipping.option
    },

    selectedOption: {
      get () {
        return this.option
      },
      set (value) {
        this.setPaymentOption(value)
      }
    }

  },

  methods: mapActions([
    'setPaymentOption',
    'requestPaymentData'
  ]),

  created () {
    this.requestPaymentData()
  },

  watch: {
    shippingOption: function (val) {
      if (val == 2 && this.selectedOption == 1) {
        this.setPaymentOption(0)
      }
    }
  }

}
</script>
